'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

/**
 * Custom modification of the shadcn/switch component:
 * - to be smaller
 * - use Venn's custom colors
 * - display ON/OFF labels
 */
const SmallSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'group relative peer inline-flex h-[16px] w-[42px] shrink-0 cursor-pointer items-center rounded-full border border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:border-venn-grey-40 data-[state=checked]:bg-venn-dark-blue data-[state=unchecked]:bg-venn-switch-light data-[state=checked]:disabled:bg-venn-grey-30 data-[state=unchecked]:disabled:bg-venn-grey-10 border-venn-dark-blue border-solid data-[state=checked]:border-none',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-[16px] w-[16px] rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-[26px] data-[state=unchecked]:-translate-x-[2px] border-venn-dark-blue group-disabled:border-venn-grey-40 group-disabled:bg-white border border-solid',
      )}
    />
    <span
      className={cn(
        'absolute left-[6px] font-bold text-white text-[10px] top-1/2 -translate-y-1/2 transition-opacity duration-300 group-disabled:text-venn-grey-80',
        props.checked ? 'opacity-100' : 'opacity-0',
      )}
    >
      ON
    </span>
    <span
      className={cn(
        'absolute right-[6px] font-bold text-venn-dark-blue group-disabled:text-venn-grey-80 text-[10px] top-1/2 -translate-y-1/2 transition-opacity duration-300',
        !props.checked ? 'opacity-100' : 'opacity-0',
      )}
    >
      OFF
    </span>
  </SwitchPrimitives.Root>
));
SmallSwitch.displayName = SwitchPrimitives.Root.displayName;

export { SmallSwitch };
